module.exports = __webpack_public_path__ + "media/27.d7ddfd96.wav";